module.exports = __webpack_public_path__ + "imgs/payment.ebaed28b727aaa6d44c8ff9ed575e26e.svg";